<mat-toolbar class="mat-elevation-z8">
  Ordernummer: <a (click)="goToOrder()" href="javascript:void()">{{data.order.orderNr}}</a>
  <div class="spacer"></div> {{data.order.orderDate | date: 'yyyy-MM-dd HH:mm'}}
</mat-toolbar>

@if (loading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content class="p-3">

  <div class="my-2">
    @if (data.booking?.status !==2) {
    <button mat-stroked-button class="mr-2" color="primary" (click)="setPaid()">Status
      Paid</button>
    }
    @if (data.booking?.status !==3) {
    <button mat-stroked-button class="mr-2" color="primary" (click)="setReserved()">Status Reserved</button>
    }
    @if (data.booking?.status ==3) {
    <button mat-stroked-button class="mr-2" color="primary"
      (click)="sendOrderParkingCheckinConfirmation(data.order.orderId)">
      <mat-icon>email</mat-icon>
      <span class="button-content">
        {{'ORDER_DETAILS.BUTTONS.SEND_PARKING_INSTRUCTIONS' | transloco}}
      </span>
    </button>
    }
  </div>

  <div class="mb-4">
    <mat-card-title class="mt-3">
      <span>{{data.order.customer.firstName}} {{data.order.customer.lastName}}</span>
    </mat-card-title>
    <mat-card-subtitle>Registreringsnummer: {{data.booking.carId}}</mat-card-subtitle>
    <mat-card-subtitle>Parkeringsstatus:
      <app-status-badge [text]="getBookingStatusText($safeNavigationMigration(data.booking?.status))"
        [isPayment]="true"></app-status-badge>
    </mat-card-subtitle>
  </div>

  <div>
    <h4 class="mb-2">Byt Parkering</h4>
    <mat-form-field appearance="outline">
      <mat-label>{{parkingSiteName}}</mat-label>
      <input type="text" matInput [formControl]="editParkingForm.controls.parkingSpot" [matAutocomplete]="autoParking">
      <mat-autocomplete class="auto-complete" #autoParking="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredAvailableParkingSpots | async; track option) {
        <mat-option [value]="option">
          {{option.parkingSiteName}}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  @if (isAdmin) {
  <div>
    <h4 class="mb-2">Byt Parkering Admin</h4>
    <mat-form-field appearance="outline">
      <mat-label>{{parkingSiteName}}</mat-label>
      <input type="text" matInput [formControl]="editAdminParkingForm.controls.parkingSpot"
        [matAutocomplete]="autoAdminParking">
      <mat-autocomplete #autoAdminParking="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredAllAvailableParkingSpots | async; track option) {
        <mat-option [value]="option">
          @if (option.parkingSiteActive) {
          <span class="text-active">{{option.parkingSiteName}}</span>
          }
          @if (!option.parkingSiteActive) {
          <span class="text-inactive">{{option.parkingSiteName}}</span>
          }
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  }

  <div class="info-grid">
    <!-- Customer Info -->
    <div class="info-section">
      <h3 class="section-title">Kundinformation</h3>
      <div class="info-item">
        <span class="info-label">Namn</span>
        <p class="info-value">{{data.order.customer.firstName}} {{data.order.customer.lastName}}</p>
      </div>
      <div class="info-item">
        <span class="info-label">Email</span>
        <p class="info-value">{{data.order.customer.email}}</p>
      </div>
      <div class="info-item">
        <span class="info-label">Mobil</span>
        <p class="info-value">{{data.order.customer.cellular}}</p>
      </div>
      @if (data.order.comment) {
      <div class="info-item">
        <span class="info-label">Kommentar</span>
        <p class="info-value">{{data.order.comment}}</p>
      </div>
      }
    </div>

    <div class="info-section">
      <h3 class="section-title">Orderinformation</h3>
      <div class="info-item">
        <span class="info-label">Status</span>
        <p class="info-value status-{{data.order.status?.toLowerCase()}}">
          {{ data.order.status }}
        </p>
      </div>
      @if (data.order.paymentType) {
      <div class="info-item">
        <span class="info-label">Betalningsstatus</span>
        <p class="info-value">{{data.order.paymentStatus}}</p>
      </div>
      }
      @if (data.order.paymentType) {
      <div class="info-item">
        <span class="info-label">Metod</span>
        <p class="info-value">{{data.order.paymentType}}</p>
      </div>
      }
      <div class="info-item">
        <span class="info-label">Belopp</span>
        <p class="info-value">{{data.order.totalPriceIncVat}} Kr</p>
      </div>
      <div class="info-item">
        <span class="info-label">Referens</span>
        <p class="info-value">{{data.order.externalBookingReference || '-'}}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [disabled]="loading" (click)="close()">Avbryt</button>
  <button mat-raised-button color="primary" [disabled]="loading" (click)="save()">Spara</button>
</mat-dialog-actions>